import React, { useEffect, useState, useRef } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Slide } from 'react-awesome-reveal';
import { Ripple } from "primereact/ripple";
import { confirmDialog } from "primereact/confirmdialog";
import { goToTop } from "../../WebApp/Components/goToTop";
import { useAuth } from "../../WebApp/Authentication/AuthContext";
import { userProfile } from "../../WebApp/Api/UserData";

const NavBar: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const currentPath = location.pathname;
    const [isScrolled, setIsScrolled] = useState<boolean>(false);
    const [showMenu, setShowMenu] = useState<boolean>(false);

    /* For auth */
    const [userData, setUserData] = useState<any>([]);
    const { logout, isAuthenticated } = useAuth();
    const [showProfileMenu, setShowProfileMenu] = useState<boolean>(false);
    const profileMenuRef = useRef<HTMLDivElement>(null);
    const profileButtonRef = useRef<HTMLButtonElement>(null);

    const hideAuthPaths = location.pathname.startsWith('/auth') || location.pathname === '/pricing';

    /* ************************************************************************ */
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const isActive = (pathName: string) => {
        if (pathName === currentPath) {
            return 'active';
        }
    }

    const handleToggleMenu = () => {
        setShowMenu(!showMenu);
    }

    const handleClickMenuLink = () => {
        setShowMenu(false);
        goToTop();
    }
    /* ************************************************************************ */

    /* ******************************* For auth ******************************* */
    useEffect(() => {
        profileData();

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const profileData = async () => {
        if (localStorage.getItem('user_id') && localStorage.getItem('token')) {
            const data = await userProfile(localStorage.getItem('token') || '');
            if (data.status) {
                setUserData(data.userData);
            }
        }
    }

    const handleLogOut = () => {
        setShowProfileMenu(false);
        setShowMenu(false);
        logout();
    };

    const handleToggleProfileMenu = () => {
        setShowProfileMenu(prevState => !prevState);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (
            profileMenuRef.current &&
            !profileMenuRef.current.contains(event.target as Node) &&
            profileButtonRef.current &&
            !profileButtonRef.current.contains(event.target as Node)
        ) {
            setShowProfileMenu(false);
        }
    };

    const handleClickLink = () => {
        handleToggleProfileMenu();
        goToTop();
    }

    /* ************************************************************************ */

    return (
        <React.Fragment>
            <nav className={`web_nav_bar ${isScrolled && 'scrolled'} ${showMenu && 'menu_toggled'} ${hideAuthPaths && 'shadowed'}`}>
                <div className="container-md">
                    <div className="nav_item_list">
                        <div className="nav_item_left">
                            <Link to={'/'} className="nav_logo_link" onClick={handleClickMenuLink}>
                                <img src="/assets/images/traqdo_logo.svg" alt="Traqdo" className="nav_logo" />
                            </Link>
                        </div>

                        {!hideAuthPaths && (
                            <div className="nav_item_center">
                                <ul className="nav_link_list">
                                    <li>
                                        <Link to={'/about-us'} className={`nav_link ${isActive('/about-us')}`}
                                            onClick={goToTop}>
                                            About
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to={'/use-case'} className={`nav_link ${isActive('/use-case')}`}
                                            onClick={goToTop}>
                                            Use Case
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to={'/pricing'} className={`nav_link ${isActive('/pricing')}`}
                                            onClick={goToTop}>
                                            Pricing
                                        </Link>
                                    </li>
                                    {/* <li>
                                    <Link to={'/blogs'} className={`nav_link ${isActive('/blogs')}`}
                                        onClick={goToTop}>
                                        Blogs
                                    </Link>
                                </li> */}
                                    <li>
                                        <Link to={'/faq'} className={`nav_link ${isActive('/faq')}`}
                                            onClick={goToTop}>
                                            Faq
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to={'/contact-us'} className={`nav_link ${isActive('/contact-us')}`}
                                            onClick={goToTop}>
                                            Contact Us
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        )}

                        <div className="nav_item_right">
                            <ul className="nav_link_list">
                                <li className="web_menu_toggle">
                                    <input
                                        hidden
                                        className="check-icon"
                                        id="check-icon"
                                        type="checkbox"
                                        checked={showMenu}
                                        onChange={handleToggleMenu}
                                    />
                                    <label className="icon-menu" htmlFor="check-icon">
                                        <div className="bar bar--1"></div>
                                        <div className="bar bar--2"></div>
                                        <div className="bar bar--3"></div>
                                    </label>
                                </li>
                                <li className="d-none d-sm-block">
                                    <Link to={'/auth/login'} className={`nav_link ${isActive('/auth/login')}`}
                                        onClick={handleClickMenuLink}>
                                        Login
                                    </Link>
                                </li>
                                <li className="d-none d-sm-block">
                                    <Link to={'/pricing'} className={`nav_link link_btn ${isActive('/auth/signup')} p-ripple`}
                                        onClick={handleClickMenuLink}>
                                        Sign Up
                                        <Ripple />
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav >

            <div className={`web_sidebar_backdrop ${showMenu ? 'show' : ''}`} onClick={handleToggleMenu}></div>

            <aside className={`web_sidebar ${showMenu && 'show'}`}>
                <ul className="sidebar_link_list">
                    <Slide direction="right">
                        <li>
                            <Link to={'/about-us'} className={`web_sidebar_link p-ripple ${isActive('/about-us')}`}
                                onClick={handleClickMenuLink}>
                                About
                                <Ripple />
                            </Link>
                        </li>
                    </Slide>

                    <Slide direction="right" delay={50}>
                        <li>
                            <Link to={'/use-case'} className={`web_sidebar_link p-ripple ${isActive('/use-case')}`}
                                onClick={handleClickMenuLink}>
                                Use Case
                                <Ripple />
                            </Link>
                        </li>
                    </Slide>

                    <Slide direction="right" delay={100}>
                        <li>
                            <Link to={'/pricing'} className={`web_sidebar_link p-ripple ${isActive('/pricing')}`}
                                onClick={handleClickMenuLink}>
                                Pricing
                                <Ripple />
                            </Link>
                        </li>
                    </Slide>

                    {/* <Slide direction="right" delay={150}>
                        <li>
                            <Link to={'/blogs'} className={`web_sidebar_link p-ripple ${isActive('/blogs')}`}
                                onClick={handleClickMenuLink}>
                                Blogs
                                <Ripple />
                            </Link>
                        </li>
                    </Slide> */}

                    <Slide direction="right" delay={200}>
                        <li>
                            <Link to={'/faq'} className={`web_sidebar_link p-ripple ${isActive('/faq')}`}
                                onClick={handleClickMenuLink}>
                                Faq
                                <Ripple />
                            </Link>
                        </li>
                    </Slide>

                    <Slide direction="right" delay={250}>
                        <li>
                            <Link to={'/contact-us'} className={`web_sidebar_link p-ripple ${isActive('/contact-us')}`}
                                onClick={handleClickMenuLink}>
                                Contact Us
                                <Ripple />
                            </Link>
                        </li>
                    </Slide>
                </ul>

                <ul className="sidebar_link_list d-sm-none">
                    <Slide direction="down" delay={50}>
                        <li>
                            <Link to={'/auth/login'} className={`web_sidebar_link as_btn light p-ripple justify-content-center ${isActive('/auth/login')}`}
                                onClick={handleClickMenuLink}>
                                Login
                                <Ripple />
                            </Link>
                        </li>
                    </Slide>

                    <Slide direction="down" delay={0}>
                        <li className="mb-0">
                            <Link to={'/pricing'} className={`web_sidebar_link p-ripple as_btn justify-content-center ${isActive('/auth/signup')}`}
                                onClick={handleClickMenuLink}>
                                Sign Up
                                <Ripple />
                            </Link>
                        </li>
                    </Slide>
                </ul>
            </aside>
        </React.Fragment>
    );

}

export default NavBar;